import React, { useEffect, useState } from 'react';

import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Fragment } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import SweetAlert from 'react-bootstrap-sweetalert';

import { useParams } from 'react-router-dom';

import OrdenCompraDetalle from 'components/Tvendo/Shopping/Operations/OrdenCompra/OrdenCompraDetalle/List';
import OCDetalleSupervisor from 'components/Tvendo/Shopping/Operations/OrdenCompra/ODetalleSupervisor/List';
import OrdenCompraDiferencias from 'components/Tvendo/Shopping/Operations/OrdenCompra/OrdenCompraDiferencia/List';
import OrdenCompraDocumentos from 'components/Tvendo/Shopping/Operations/OrdenCompra/OrdenCompraDocumento/List';

import { Toasty, useToasty } from 'hooks/Toasty';
import { wsRemove } from 'services/WService';

//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import { wsGet } from 'services/WService';
import { wsFindBy } from 'services/WService';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { currency } from 'hooks/Pipe';

const useStyles = makeStyles(styles);

export default function () {
  const claseStyleTab = useStyleTabs();
  const classes = useStyles();

  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [notify, showNotify] = useToasty();
  const [alertState, setAlertState] = useState(null);

  const themeTab = useTheme();
  const permission = {
    supervisor: 'PURCH_PURCHASES_SUPERVISOR_INDEX',
    logistic: 'PURCH_PURCHASES_BOSSLOGISTIC_INDEX',
    logistic_supervisor: ['PURCH_PURCHASES_BOSSLOGISTIC_INDEX','PURCH_PURCHASES_SUPERVISOR_INDEX'],
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirm(entity, id, reload) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Esta seguro de eliminar!"
        onConfirm={() => {
          remove(entity, id, reload);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  async function remove(entity, id, reload) {
    let response = await wsRemove(entity, id);
    if (response.success) {
      showNotify(response.message);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  //#region Listados de api
  const [ordenCompra, setOrdenCompra] = useState({});
  const [oCDetails, setOCDetails] = useState([]);
  const [oCDiferencia, setOCDiferencia] = useState([]);
  const [oCDocumento, setOCDocumento] = useState([]);

  async function getOrdenCompra() {
    let response = await wsGet('purch/purchase-order', id);
    if (response.success) {
      setOrdenCompra(response.data);
      // setGIDetails(response.data.details);
      // setGICanals(response.data.canals);
    }
  }
  async function getOrdenCompraDetail() {
    let response = await wsFindBy('purch/purchase-order-detalle', { purch_order_id: ordenCompra.id });
    if (response.success) setOCDetails(response.data);
  }
  async function getOrdenCompraDiferencia() {
    let response = await wsFindBy('purch/purchase-order-diferencia', { purch_order_id: ordenCompra.id });
    if (response.success) setOCDiferencia(response.data);
  }
  async function getOrdenCompraDocumentos() {
    let response = await wsFindBy('purch/get-order-documents', { purch_order_id: ordenCompra.id });
    if (response.success) setOCDocumento(response.data);
  }

  useEffect(() => {
    getOrdenCompra();
  }, []);

  useEffect(()=> {
    if(ordenCompra.id){
      getOrdenCompraDetail();
      getOrdenCompraDiferencia();
      getOrdenCompraDocumentos();
    }
  },[ordenCompra.id]);

  let state;
  switch (ordenCompra.state) {
    case 'D': state = ' - Estado: Borrador'; break;
    case 'V': state = ' - Estado: Validado'; break;
    case 'C': state = ' - Estado: Confirmado'; break;
    case 'S': state = ' - Estado: Enviado'; break;
    case 'R': state = ' - Estado: Recibido'; break;
    case 'F': state = ' - Estado: Finalizado'; break;
    case 'A': state = ' - Estado: Anulado'; break;
    default: state = ''; break;
  }
  let Provider = '';
  if (ordenCompra.CardName !== undefined) {
    Provider = `Proveedor: ${ordenCompra.CardName}`;
  }
  let totalPOrder = '';
  if (ordenCompra.DocTotal !== undefined) {
    totalPOrder = `- Total orden compra: ${currency(ordenCompra.DocTotal)}`;
  }
  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      {alertState}
      {id != 0 ? (
        <Fragment>
          <h4 style={{ fontWeight: 'bold' }}>{Provider}{state}{totalPOrder}</h4>
          <div className={claseStyleTab.root}>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                textColor="secondary"
                aria-label="Tabs"
                indicatorColor="secondary"
              >
                {/* <AllowedGuard permission={ConstantPermissions[permission.logistic_supervisor]}> */}
                  <Tab label="Detalles supervisor" {...indexTab(0)} />
                {/* </AllowedGuard> */}
                {/* <AllowedGuard permission={ConstantPermissions[permission.logistic]}> */}
                  <Tab label="Detalle" {...indexTab(1)} />
                {/* </AllowedGuard> */}
                {/* <AllowedGuard permission={ConstantPermissions[permission.logistic]}> */}
                  <Tab label="Diferencias" {...indexTab(2)} />
                  <Tab label="Documentos" {...indexTab(3)} />
                {/* </AllowedGuard> */}
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              {/* <AllowedGuard permission={ConstantPermissions.PURCH_PURCHASES_SUPERVISOR_INDEX}> */}
              <AllowedGuard permission={ConstantPermissions[permission.logistic_supervisor]}>
                <TabPanel value={value} index={0} dir={themeTab.direction}>
                  <OCDetalleSupervisor
                    id={id}
                    showNotify={showNotify}
                    confirm={confirm}
                    oCDetails={oCDetails}
                    setOCDetails={setOCDetails}
                    ordenCompra={ordenCompra}
                    reload={getOrdenCompraDetail}
                  />
                </TabPanel>
              </AllowedGuard>
              <AllowedGuard permission={ConstantPermissions[permission.logistic]}>
                <TabPanel value={value} index={1} dir={themeTab.direction}>
                  <OrdenCompraDetalle
                    id={id}
                    showNotify={showNotify}
                    confirm={confirm}
                    oCDetails={oCDetails}
                    setOCDetails={setOCDetails}
                    ordenCompra={ordenCompra}
                    reload={getOrdenCompraDetail}
                    reloadPurchOrder={getOrdenCompra}
                    alertState = {alertState}
                    setAlertState = {setAlertState}
                    />
                </TabPanel>
              </AllowedGuard>
              <AllowedGuard permission={ConstantPermissions[permission.logistic]}>
                <TabPanel value={value} index={2} dir={themeTab.direction}>
                  <OrdenCompraDiferencias
                    id={id}
                    showNotify={showNotify}
                    confirm={confirm}
                    oCDiferencia={oCDiferencia}
                    oCDetails={oCDetails}
                    setOCDiferencia={setOCDiferencia}
                    ordenCompra={ordenCompra}
                    reload={getOrdenCompraDiferencia}
                  />
                </TabPanel>
              </AllowedGuard>
              <AllowedGuard permission={ConstantPermissions[permission.logistic]}>
                <TabPanel value={value} index={3} dir={themeTab.direction}>
                  <OrdenCompraDocumentos
                    id={id}
                    showNotify={showNotify}
                    confirm={confirm}
                    oCDocumento={oCDocumento}
                    setOCDocumento={setOCDocumento}
                    ordenCompra={ordenCompra}
                    reload={getOrdenCompraDocumentos}
                  />
                </TabPanel>
              </AllowedGuard>
            </SwipeableViews>
          </div>
        </Fragment>
      ) : undefined}
    </Fragment>
  );
}
